<template lang="pug">
.CustomizeTopPage
  .content
    .settings
      .title 設定
      .category カスタマイズ
      table
        tr
          th キャラクター
          td
            select(v-model="modifiedCharacterType")
              option(:value="0") ロボット
              option(:value="1") 動物
              option(:value="2") 魔法使い
              option(:value="3") ハードボイルド
      .category サウンド
      table
        tr
          th 効果音の有無
          td
            select(@change="handleEffectSoundMuteSettingChange($event)")
              option(:value="false" :selected="isEffectSoundMuted === false") 音あり
              option(:value="true" :selected="isEffectSoundMuted === true") 音なし
        tr
          th BGMの有無
          td
            select(@change="handleBGMSoundMuteSettingChange($event)")
              option(:value="false" :selected="isBGMSoundMuted === false") 音あり
              option(:value="true" :selected="isBGMSoundMuted === true") 音なし
      .category アカウント
      table
        tr
          th ユーザー名の変更
          td
            input(v-model="name")
            button(@click="handleChangeUserNameButtonClick") 変更
        tr
          th メールアドレスの変更
          td
            input(v-model="email")
            button(@click="handleChangeUserEmailButtonClick") 変更
        tr
          th パスワードの再設定
          td
            input(v-model="emailForResetPassword")
            button(@click="handleResetPasswordButtonClick") 送信
      .category(v-if="constants.IS_DEBUG") その他
      table(v-if="constants.IS_DEBUG")
        tr
          th デバッグ
          td
            button(@click="handleResetUserDataButtonClick") 個人データリセット
            button(@click="handleResetLessonDataButtonClick") レッスンデータリセット
            button(@click="handleResetChallengeDataButtonClick") 測定チャレンジデータリセット
            button(@click="handleFinishLessonButtonClick") レッスンクリア済みデータをセット
  km-footer(
    title="設定"
  )
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as constants from '@/constants'
import soundService from '@/services/SoundService'
import firebase from 'firebase'

export default {
  name: 'customize-top-page',
  components: {},
  data() {
    return {
      constants,
      modifiedCharacterType: 0,
      email: null,
      emailForResetPassword: null
    }
  },
  watch: {
    modifiedCharacterType: function() {
      this.setCharacterType(this.modifiedCharacterType)
    }
  },
  computed: {
    ...mapState('Character', {
      characterType: state => state.type
    }),
    ...mapState('User', {
      account: state => state.account,
      isEffectSoundMuted: state => state.isEffectSoundMuted,
      isBGMSoundMuted: state => state.isBGMSoundMuted
    })
  },
  methods: {
    ...mapActions('Sound', ['playBGM', 'stopBGM']),
    ...mapActions('Character', ['setCharacterType']),
    ...mapActions('User', [
      'resetUserData',
      'resetProgress',
      'setFinishedLessonProgress',
      'resetChallengeResult',
      'setEffectSoundMuteStatus',
      'setBGMSoundMuteStatus'
    ]),
    sendResetPasswordEmail() {
      firebase
        .auth()
        .sendPasswordResetEmail(this.emailForResetPassword)
        .then(() => {
          alert(`${this.emailForResetPassword}へ確認メールが送信されました`)
        })
        .catch(error => {
          switch (error.code) {
            default:
              alert(
                '確認メールの送信に失敗しました。ログインし直してください。'
              )
              break
          }
        })
    },
    async changeScoresUserName(inputedName) {
      const user = firebase.auth().currentUser
      await firebase
        .firestore()
        .collection('scores')
        .doc(user.uid)
        .update({
          name: inputedName
        })
    },
    changeUserName() {
      const user = firebase.auth().currentUser
      firebase
        .firestore()
        .collection('user_info')
        .doc(user.uid)
        .update({
          name: this.name
        })
        .then(() => {
          this.changeScoresUserName(this.name)
          this.$store.dispatch('User/setName', this.name)
        })
        .then(() => {
          alert('ユーザー名を変更しました')
        })
        .catch(error => {
          console.log(error)
          alert('ユーザー名の変更に失敗しました。ログインし直してください。')
        })
    },
    changeUserEmail() {
      const user = firebase.auth().currentUser
      user
        .updateEmail(this.email)
        .then(() => {
          this.$store.dispatch('User/setEmail', this.email)
        })
        .then(() => {
          alert('メールアドレスを変更しました')
        })
        .catch(error => {
          console.log(error)
          alert(
            'メールアドレスの変更に失敗しました。ログインし直してください。'
          )
        })
    },
    finishLesson() {
      this.setFinishedLessonProgress()
    },
    handleResetUserDataButtonClick() {
      this.resetUserData()
      alert('個人データをリセットしました')
    },
    handleResetLessonDataButtonClick() {
      this.resetProgress()
      alert('基本レッスンの記録をリセットしました')
    },
    handleResetChallengeDataButtonClick() {
      this.resetChallengeResult()
      const user = firebase.auth().currentUser
      firebase
        .firestore()
        .collection('scores')
        .doc(user.uid)
        .update({
          score: 0,
          date: '',
          backspaceCount: 0,
          status: false
        })
      alert('測定チャレンジの結果をリセットしました')
    },
    handleEffectSoundMuteSettingChange(event) {
      const isMuted = event.target.value === 'true'
      this.setEffectSoundMuteStatus(isMuted)
      soundService.setMute('effect', isMuted)
    },
    handleBGMSoundMuteSettingChange(event) {
      const isMuted = event.target.value === 'true'
      this.setBGMSoundMuteStatus(isMuted)
      soundService.setMute('bgm', isMuted)
    },
    handleResetPasswordButtonClick() {
      this.sendResetPasswordEmail()
    },
    handleChangeUserNameButtonClick() {
      this.changeUserName()
    },
    handleChangeUserEmailButtonClick() {
      this.changeUserEmail()
    },
    handleFinishLessonButtonClick() {
      this.finishLesson()
    }
  },
  created() {
    this.email = this.account.email
    this.emailForResetPassword = this.account.email
    this.name = this.account.name
  },
  mounted() {
    this.playBGM('bgmMenu')
    this.modifiedCharacterType = this.characterType
  }
}
</script>

<style lang="scss" scoped>
.CustomizeTopPage {
  height: 100%;
  width: 100%;
  background: #eee;
}

.content {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  width: 100%;
  height: calc(100% - 80px);
  overflow: scroll;
}

.settings {
  margin: 0 30px;
  padding: 0;
  border: 2px solid #000;
  background: #fff;

  .title {
    margin: 0;
    padding: 20px 30px;
    color: #000;
    font-size: 3rem;
    font-weight: bold;
    text-align: center;
  }

  .category {
    padding: 5px 10px;
    background: #ddd; // eadcc7, 8697bc
    color: #000;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;

  tr {
    border-bottom: 1px solid #000;
    &:last-child {
      border-bottom: 0;
    }
  }

  th,
  td {
    padding: 15px 20px;
    font-size: 2rem;
  }

  th {
    width: 300px;
    text-align: left;
  }
}

select,
input,
button {
  padding: 5px 10px;
  font-size: 1.6rem;
  appearance: none;
}

input {
  margin: 0 10px 0 0;
}
</style>
